import NotImplemented from "../../exceptions/not-implemented";
import GamedayApiService from "../gameday-api-service";
import { gameRepository } from "../../storage/storage";

export class BoxscoreService {
    async saveBoxscore(eventId) {
        const boxscore = await this.serialize(eventId);
        return GamedayApiService.saveBoxscore(boxscore);
    }

    async saveBoxscoreByGameId(gameId) {
        const { eventId } = await gameRepository.getById(gameId);
        const boxscore = await this.serialize(eventId);
        return GamedayApiService.saveBoxscore(boxscore);
    }

    async serialize() {
        throw new NotImplemented();
    }
}
